export default "__VITE_ASSET__DSbfNxlm__"